var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-complete"},[_c('div',[_vm._m(0),(_vm.isGet)?_c('user-form',{ref:"userForm",staticClass:"trial-form",attrs:{"user":_vm.user}}):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h4',[_vm._v("完善您的账户信息")])])
}]

export { render, staticRenderFns }